import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 bg-stone-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-green-900 mb-8">Refund Policy</h1>
          <div className="bg-white rounded-xl border border-stone-200 p-8 space-y-6 text-stone-700 leading-relaxed">
            <p>At Nark Online, we aim to ensure customer satisfaction.</p>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Eligibility for Refunds</h2>
              <p>Refunds may be issued if:</p>
              <ul className="list-disc pl-6 space-y-1 mt-1">
                <li>The wrong item was delivered</li>
                <li>Items are missing</li>
                <li>Items are damaged upon delivery</li>
                <li>Orders cannot be fulfilled</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Non-Refundable</h2>
              <p>Refunds will not be issued for:</p>
              <ul className="list-disc pl-6 space-y-1 mt-1">
                <li>Change of mind after order confirmation</li>
                <li>Minor variations in product appearance</li>
                <li>Delays outside our control</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Delivery Fees</h2>
              <p>Delivery fees (R30) are non-refundable once delivery has been attempted.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Refund Process</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Customers must report issues within 24 hours of delivery</li>
                <li>Refunds are processed back to the original payment method</li>
                <li>Processing time: 3–7 business days</li>
              </ul>
            </section>

            <section className="pt-4 border-t border-stone-200">
              <p className="text-sm text-stone-500">Nark Online reserves the right to investigate all claims before issuing refunds.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RefundPolicy;
